import { render } from "./ActivitatView.vue?vue&type=template&id=11988d82&scoped=true"
import script from "./ActivitatView.vue?vue&type=script&lang=js"
export * from "./ActivitatView.vue?vue&type=script&lang=js"

import "./ActivitatView.vue?vue&type=style&index=0&id=11988d82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11988d82"]])

export default __exports__